import React from 'react';
import type { FC, PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Footer } from '../footer';
import { Header } from '../header';
import { ErrorSaveHeader } from './ErrorSaveHeader';

export const ErrorSaveLayout: FC<PropsWithChildren> = ({ children }) => (
    <>
        <ErrorBoundary fallback={<ErrorSaveHeader />}>
            <Header />
        </ErrorBoundary>
        {children}
        <ErrorBoundary fallback={null}>
            <Footer />
        </ErrorBoundary>
    </>
);
